import {request} from "./request";

export function getGameWorldRankData(id,token) {
  return request({
    url: '/game/worldRank',
    data:{
      'gameId':id,
      'page':1,
      'pageSize':10
    }
  },token)
}export function getWorldRankData(token) {
  return request({
    url: '/user/worldRank',
    data:{
      'page':1,
      'pageSize':10
    }
  },token)
}
